import { render } from "./NoMetrics.vue?vue&type=template&id=fdddb4f0&lang=pug"
import script from "./NoMetrics.vue?vue&type=script&lang=js"
export * from "./NoMetrics.vue?vue&type=script&lang=js"

import "./NoMetrics.vue?vue&type=style&index=0&id=fdddb4f0&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__